module.exports = __webpack_public_path__ + "img/orbit-planets.422761d8.png";